import { TenantGeneralData } from './tenantGeneralData';
import { Commodity } from './commodity';
import { Crop } from './crop';
import { FieldActivityPlan } from './fieldActivityPlan';

export class Batch extends TenantGeneralData {
  name: string = null;
  status: string = null;
  commodity: Commodity = null;
  crops: Array<Crop> = [];
  plans: Array<FieldActivityPlan> = [];

  constructor() {
    super();
  }
}
